// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__BJTEs","notes__block":"Notes_notes__block__PxJUd"};